import * as React from 'react';
import { SelectMultiple, SelectMultipleHierarchy } from 'app/area/shared/translated-components';
import { LoadOptions } from 'app/types-shared';
import { FilterCommonProps, FilterCommonValues } from './types';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { defaultApplication } from 'app/area/search-filters/constants';
import { SelectMultipleHierarchyProps } from 'ui/select-multiple-hierarchy/select-multiple-hierarchy';
import styles from './filter-default-value-multiple.scss';

export class FilterDefaultValueMultiple extends React.PureComponent<FilterCommonProps<string>, { loadedOptions: LoadOptions }> {
  public state: Readonly<{ loadedOptions: LoadOptions }> = {
    loadedOptions: {}
  };

  private codetableId = () => this.props.defaultValue?.codetableId?.[0]?.value;

  private onChange = (values: FilterCommonValues<string>[]) => {
    this.props.onChange(this.props.id, values);
  };

  private onLoadOptions = (options: LoadOptions) => {
    const { id, onLoadOptions, optionsEndpoint, optionsParams } = this.props;
    const caseTypeId = { caseTypeId: defaultApplication };

    onLoadOptions(
      id,
      replaceTemplateString(optionsEndpoint, this.codetableId()),
      options,
      { ...optionsParams, ...caseTypeId }
    );
    this.setState({ loadedOptions: options });
    return;
  };

  public render() {
    const {
      id, label, values, options, fetchingOptions, isHierarchy = true, optionsParams, translation,
      defaultValue, meatballPanelConfiguration, locale
    } = this.props;

    const selectComponentProps: SelectMultipleHierarchyProps = {
      componentId: id,
      className: defaultValue?.readOnly ? styles.readOnly : undefined,
      label: label ? { text: label } : undefined,
      info: defaultValue?.readOnly ? { text: translation.default_value_info_text, visible: true } : undefined,
      readOnly: defaultValue?.readOnly,
      valueItems: values || [],
      onChange: this.onChange,
      options,
      fetching: fetchingOptions,
      loadOptions: this.state.loadedOptions,
      onLoadOptions: this.onLoadOptions,
      minLength: optionsParams?.minLength,
      placeholder: translation?.search,
      displaySelectAll: true,
      meatballPanelConfiguration,
      locale
    };

    return isHierarchy
      ? <SelectMultipleHierarchy {...selectComponentProps} descriptionAllLevels={true} />
      : <SelectMultiple {...selectComponentProps} />;
  }
}
